import { createFileRoute } from '@tanstack/react-router';
import { ChartsPage } from '@/features/charts';
// the schema module only: the route config is in the main bundle, the page stays in the lazy chunk
import { chartsSearchSchema } from '@/features/charts/search';

/** "Grafiklar boshqaruvi" (03-modules §6: 565:23032, 565:23476, 565:24006, 565:24468). */
export const Route = createFileRoute('/_authed/t/$tenantSlug/_shell/devices/charts')({
  validateSearch: chartsSearchSchema,
  component: ChartsRoute,
});

function ChartsRoute() {
  const { tenant, me } = Route.useRouteContext();
  const search = Route.useSearch();
  const navigate = Route.useNavigate();
  return (
    <ChartsPage
      tenant={tenant}
      userId={me.user.id}
      search={search}
      onSearch={(patch, opts) => void navigate({ search: (prev) => ({ ...prev, ...patch }), replace: opts?.replace })}
    />
  );
}
